export class ChepLocationSynchronizationResult {

  public glid: string;
  public status: ChepLocationSynchronizationStatus;
  public reason: string;
  public errorMessageKey: string;


  public static fromDto(d: any): ChepLocationSynchronizationResult {
    if (!d) {
      return null;
    }

    const result = new ChepLocationSynchronizationResult();

    result.glid         = d.glid;
    result.status       = d.status;
    result.reason       = d.reason;
    result.errorMessageKey = d.error_message_key;

    return result;
  }

  public succeed(): boolean {
    return this.status === ChepLocationSynchronizationStatus.SUCCEED;
  }
}

export enum ChepLocationSynchronizationStatus {
  SUCCEED = 'SUCCEED',
  FAILED  = 'FAILED'
}
